module.exports = __webpack_public_path__ + "e71c39ce75d3ea5ede66437935aabb04.png";